import React, { Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import API from '../../services/API';
import { Nav, NavItem, NavLink, TabContent, TabPane, Table, Button } from 'reactstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Papa from "papaparse";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import classnames from "classnames";
import moment from 'moment';
import AddTimetableModal from "../dashboard/Timetable/AddTimeTableModal";
import TimetableTab from '../dashboard/Timetable/TimetableTab';

import dayjs from 'dayjs'; // Import dayjs for date handling

const Modal = ({
    isOpen,
    toggle,
    children,
    size = "md",
    centered,
    contentClassName,
}) => {
    if (!isOpen) return null;

    const sizeClass = size ? ` modern-modal-${size}` : "";

    return (
        <div
            className="modern-modal-backdrop"
            onMouseDown={toggle}
            role="dialog"
            aria-modal="true"
        >
            <div
                className={`modern-modal-card${sizeClass} ${contentClassName || ""}`}
                onMouseDown={(event) => event.stopPropagation()}
            >
                {children}
            </div>
        </div>
    );
};

const ModalHeader = ({ children, toggle }) => {
    return (
        <div className="modern-modal-header">
            <div className="modern-modal-title-wrap">
                <div className="modern-modal-kicker">SPGO Portal</div>
                <h5 className="modern-modal-title">{children}</h5>
            </div>

            {toggle && (
                <button
                    type="button"
                    className="modern-modal-close"
                    onClick={toggle}
                    aria-label="Tutup"
                >
                    ×
                </button>
            )}
        </div>
    );
};

const ModalBody = ({ children }) => {
    return <div className="modern-modal-body">{children}</div>;
};

const ModalFooter = ({ children }) => {
    return <div className="modern-modal-footer">{children}</div>;
};

const DepartmentProfile = () => {
    const glowingIcon = L.divIcon({
        className: "", // leave blank so only our HTML applies
        html: `<div class="glow-circle"></div>`,
        iconSize: [70, 70],   // overall container size
        iconAnchor: [0, 0], // anchor in the center
    });


    const classId = window.location.pathname.split('/').pop(); // Extract class ID from URL
    const [students, setStudents] = useState({ detailed_records: [] });
    const [className, setClassName] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date()); // Selected date on the calendar
    const [loading, setLoading] = useState(false);
    const [allClasses, setAllClasses] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [newClassId, setNewClassId] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [nameModalOpen, setNameModalOpen] = useState(false);
    const [newStudentName, setNewStudentName] = useState('');
    const [summary, setSummary] = useState([]);
    const [recordModalOpen, setRecordModalOpen] = useState(false);
    const [recordStartDate, setRecordStartDate] = useState('');
    const [recordEndDate, setRecordEndDate] = useState('');
    const [recordStatus, setRecordStatus] = useState(1);
    const [recordRemarks, setRecordRemarks] = useState('');
    const [mcReasons, setMCReasons] = useState([]);
    const [selectedMCReason, setSelectedMCReason] = useState(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [studentToDelete, setStudentToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);
    const [confirmPresentModalOpen, setConfirmPresentModalOpen] = useState(false);
    const [unrecordedList, setUnrecordedList] = useState([]);
    const [registerModalOpen, setRegisterModalOpen] = useState(false);
    const [registering, setRegistering] = useState(false);
    const [newStudent, setNewStudent] = useState({
        first_name: "",
        moeis_name: "",
        class_id: classId,
    });
    const [csvFile, setCsvFile] = useState(null);
    const [activeTab, setActiveTab] = useState("manual"); // "manual" or "csv"
    const [parsedCsvNames, setParsedCsvNames] = useState([]);
    const [rawInput, setRawInput] = useState("");
    const [rawNames, setRawNames] = useState([]);
    const [rawCheckResults, setRawCheckResults] = useState(null);
    const [csvCheckResults, setCsvCheckResults] = useState(null);
    const [confirmAbsentModalOpen, setConfirmAbsentModalOpen] = useState(false);
    const [selectedBulkMCReason, setSelectedBulkMCReason] = useState(null);
    // states
    const [activeSubTab, setActiveSubTab] = useState("students");
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [timetable, setTimetable] = useState([]);
    const [rotationCycle, setRotationCycle] = useState(1);

    const [loadingTimetable, setLoadingTimetable] = useState(false);
    const [teachers, setTeachers] = useState([]);
    const [startBulkDate, setStartBulkDate] = useState("");
    const [endBulkDate, setEndBulkDate] = useState("");
    const [activeMonthDate, setActiveMonthDate] = useState(new Date());
    const [isArchiveModalOpen, setIsArchiveModalOpen] = useState(false);
    const [isArchiving, setIsArchiving] = useState(false);
    // Add this state to manage the temporary list in the modal
    const [studentsToArchive, setStudentsToArchive] = useState([]);

    // Function to initialize the list when opening the modal
    const openArchiveModal = () => {
        const studentList = Object.values(groupedRecords);
        setStudentsToArchive(studentList);
        setIsArchiveModalOpen(true);
    };
    // Function to remove a student from the temporary list
    const handleRemoveFromArchiveList = (student_uuid) => {
        setStudentsToArchive(prev => prev.filter(s => s.student_uuid !== student_uuid));
    };
    // tab toggle
    const toggleSubTab = (tab) => {
        if (activeSubTab !== tab) setActiveSubTab(tab);
    };
    const [selectedDay, setSelectedDay] = useState("Monday");

    const filteredTimetable = timetable.filter(
        (item) => item.day_of_week === selectedDay
    );

    const statusMap = {
        "0": { text: "Belum Direkod", color: "secondary" },
        "1": { text: "Sedang Direkod", color: "warning" },
        "2": { text: "Direkod (Waris Disambung)", color: "info" },
        "4": { text: "Direkod", color: "success" },
        "error": { text: "Ralat / Konflik", color: "danger" },
        "duplicate": { text: "Rekod Berganda", color: "dark" },
        "conflict": { text: "Konflik Jabatan", color: "danger" },
    };


    const openDeleteModal = (student) => {
        setStudentToDelete(student);
        setDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setDeleteModalOpen(false);
        setStudentToDelete(null);
    };

    useEffect(() => {
        getClassName();
        fetchAllClasses();
        getMCReasons();
    }, [classId]);

    const openRecordAttendanceModal = (student) => {
        setSelectedStudent(student);
        setRecordStartDate(dayjs(selectedDate).format('YYYY-MM-DD'));
        setRecordEndDate(dayjs(selectedDate).format('YYYY-MM-DD'));
        setRecordStatus(1);
        setRecordRemarks('');
        setRecordModalOpen(true);
    };


    const openNameModal = (student) => {
        setSelectedStudent(student);
        setNewStudentName(student.first_name);
        setNameModalOpen(true);
    };

    const closeNameModal = () => {
        setSelectedStudent(null);
        setNewStudentName('');
        setNameModalOpen(false);
    };
    const fetchTeachers = () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        API.get('/portal/getTeachers', { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {

                    const teacherOptions = response.data.data.map((teacher) => ({
                        label: teacher.full_name,
                        value: teacher.teacher_uuid,
                    }));

                    setTeachers(teacherOptions);
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Ralat mendapatkan senarai pegawai", { autoClose: 5000 });
            });
    };

    const updateStudentName = async () => {
        if (!selectedStudent || !newStudentName.trim()) {
            toast.error("Sila masukkan nama yang sah.", { autoClose: 5000 });
            return;
        }

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.post(
                '/portal/modifyStudentName',
                { student_id: selectedStudent.student_uuid, new_name: newStudentName.trim() },
                { headers }
            );

            if (response.data.response_code === 1000) {
                toast.success("Nama pegawai berjaya dikemaskini!", { autoClose: 5000 });
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
                closeNameModal();
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            toast.error(`Ralat mengemaskini nama pegawai ${error}`, { autoClose: 5000 });
        }
    };
    const getClassName = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.post(
                `/school/classID`,
                { class_id: classId }, // Include class_id and date in the body
                { headers }
            );
            if (response.data.response_code === 1000) {
                setClassName(response.data.data.class_name || ''); // Update students data
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            toast.error("Ralat mendapatkan nama jabatan", { autoClose: 5000 });
        } finally {

        }
    }
    const fetchTimetable = async () => {
        setLoadingTimetable(true);
        try {
            const token = localStorage.getItem("token");
            const response = await API.get("/timetable/list", {
                headers: { token },
                params: { is_portal: true, class_id: classId },
            });

            if (response.data.response_code === 1000) {
                setTimetable(response.data.data || []);
            } else {
                toast.error(response.data.message || "Gagal mendapatkan jadual bertugas");
                setTimetable([]);
            }
        } catch (error) {
            console.error("❌ Timetable fetch error:", error);
            toast.error("Ralat mendapatkan jadual bertugas");
            setTimetable([]);
        } finally {
            setLoadingTimetable(false);
        }
    };

    const handleBulkArchiveClass = async () => {
        if (studentsToArchive.length === 0) {
            toast.error("Tiada pegawai dipilih untuk diarkibkan.");
            return;
        }

        setIsArchiving(true);
        const headers = {
            'Content-Type': 'application/json',
            'token': localStorage.getItem('token'),
        };

        const payload = {
            students: studentsToArchive.map(student => ({
                moeis_name: student.moeis_name,
                class_id: classId
            }))
        };

        try {
            const response = await API.post('/student/bulkArchiveStudentsByMoeisAndClass', payload, { headers });
            if (response.data.response_code === 1000) {
                toast.success(`Berjaya mengarkibkan ${studentsToArchive.length} pegawai.`);
                setIsArchiveModalOpen(false);
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
            } else {
                toast.error(response.data.message || "Gagal mengarkibkan pegawai.");
            }
        } catch (error) {
            toast.error("Ralat berlaku semasa proses arkib.");
        } finally {
            setIsArchiving(false);
        }
    };

    const fetchAllClasses = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        try {
            const response = await API.get(`/school/classes`, { headers });
            if (response.data.response_code === 1000) {
                setAllClasses(response.data.data || []);
            } else {
                toast.error("Gagal mendapatkan senarai jabatan", { autoClose: 5000 });
            }
        } catch (error) {
            toast.error("Ralat mendapatkan senarai jabatan", { autoClose: 5000 });
        }
    };
    const fetchStudentsAttendanceSummary = async (date) => {
        setLoading(true);
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        const formattedDate = dayjs(date).format('YYYY-MM'); // Format as YYYY-MM-DD

        try {
            const response = await API.post(
                `/attendance/attendanceByClassSummary`,
                { class_id: classId, month: formattedDate }, // Include class_id and date in the body
                { headers }
            );

            if (response.data.response_code === 1000) {
                const result = response.data.data || {};

                setSummary({
                    date_summary: result.date_summary || [],
                    holidays: result.holidays || [],
                });
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Error fetching students:', error);
            toast.error("Ralat mendapatkan senarai pegawai", { autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    };
    // Fetch students based on class and selected date
    const fetchStudentsAttendanceDetail = async (date) => {
        setLoading(true);
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        const formattedDate = dayjs(date).format('YYYY-MM-DD'); // Format as YYYY-MM-DD

        try {
            const response = await API.post(
                `/attendance/attendanceByClassDetail`,
                { class_id: classId, date: formattedDate }, // Include class_id and date in the body
                { headers }
            );
            if (response.data.response_code === 1000) {
                const data = response.data.data;

                // ✅ normalize to { detailed_records: [] }
                if (Array.isArray(data)) {
                    setStudents({ detailed_records: data });
                } else {
                    setStudents({
                        detailed_records: Array.isArray(data?.detailed_records) ? data.detailed_records : []
                    });
                }
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
                setStudents({ detailed_records: [] });
            }
        } catch (error) {
            console.error('Error fetching students:', error);
            toast.error("Ralat mendapatkan senarai pegawai", { autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    };
    const confirmDeleteStudent = async () => {
        if (!studentToDelete) return;
        setDeleting(true);

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        try {
            const response = await API.post(
                '/portal/delete',
                { student_id: studentToDelete.student_uuid },
                { headers }
            );
            if (response.data.code === 1000 || response.data.response_code === 1000) {
                toast.success(response.data.message || "Pegawai berjaya dipadam!", { autoClose: 5000 });
                // Refresh data after deletion
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
            } else {
                toast.error(response.data.message || "Gagal memadam pegawai", { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Delete student error:', error);
            toast.error("Ralat memadam pegawai", { autoClose: 5000 });
        } finally {
            setDeleting(false);
            closeDeleteModal();
        }
    };
    const confirmMarkAllAsPresent = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');

        setLoading(true);
        try {
            await Promise.all(
                unrecordedList.map(student => {
                    const payload = {
                        class_id: classId,
                        student_uuid: student.student_uuid,
                        start_date: formattedDate,
                        end_date: formattedDate,
                        status: 1,
                        remarks: '',
                        reason_type: "",
                    };
                    return API.post('/attendance/teacher/record', payload, { headers });
                })
            );

            toast.success("Semua pegawai yang belum direkod telah ditanda sebagai hadir.", { autoClose: 5000 });
            fetchStudentsAttendanceDetail(selectedDate);
            fetchStudentsAttendanceSummary(selectedDate);
            setConfirmPresentModalOpen(false);
        } catch (error) {
            console.error("Error bulk updating:", error);
            toast.error("Gagal mengemaskini sebahagian pegawai", { autoClose: 5000 });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const loadRotation = async () => {
            const token = localStorage.getItem("token");
            const res = await API.get("/timetable/rotation/info", {
                headers: { token, is_portal: true }
            });

            if (res.data.response_code === 1000) {
                setRotationCycle(res.data.rotation_cycle || 1);
            }
        };

        loadRotation();
    }, []);

    useEffect(() => {
        if (!classId) return;
        fetchStudentsAttendanceSummary(activeMonthDate);
    }, [classId, activeMonthDate]);

    useEffect(() => {
        if (!classId) return;
        fetchStudentsAttendanceDetail(selectedDate);
    }, [classId, selectedDate]);

    useEffect(() => {
        if (activeSubTab === "timetable") {
            fetchTeachers();
            fetchTimetable();
        }
    }, [activeSubTab]);

    const tileContent = ({ date, view }) => {
        if (view !== "month") return null;

        const formattedDate = dayjs(date).format("YYYY-MM-DD");


        const isHoliday = summary?.holidays?.some(h => h.date === formattedDate);
        if (isHoliday) {
            return (
                <div
                    style={{

                    }}
                />
            );
        }

        const record = summary?.date_summary?.find(item => item.date === formattedDate);
        if (!record || record.total_students === 0) return null;

        const ratio = record.total_present / record.total_students;
        const percentage = Math.round(ratio * 100);


        let background = "#f5f6fa";
        let color = "#555";

        if (ratio >= 0.8) { background = "#E8F5E9"; color = "#2E7D32"; }   // good (green)
        else if (ratio >= 0.5) { background = "#FFF8E1"; color = "#8A6D3B"; } // fair (yellow)
        else { background = "#FFEBEE"; color = "#C62828"; }                   // low (red)
        const isMobile = window.innerWidth < 600;

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    background,
                    color,
                    borderRadius: "8px",
                    padding: window.innerWidth < 600 ? "4px" : "6px",
                    fontWeight: 600,
                    fontSize: window.innerWidth < 600 ? "0.75rem" : "0.85rem",
                    textAlign: "center",
                    lineHeight: 1.2,
                    boxSizing: "border-box",
                }}
            >
                {isMobile ? (
                    // 📱 Show only percentage
                    <span>{percentage}%</span>
                ) : (
                    // 💻 Show both ratio and %
                    <>
                        <span>{record.total_present}/{record.total_students}</span>
                        <span style={{ fontSize: "0.7rem", opacity: 0.8 }}>{percentage}%</span>
                    </>
                )}
            </div>
        );


    };

    // Group and filter detailed records by student_uuid and selected date
    const formattedSelectedDate = dayjs(selectedDate).format('YYYY-MM-DD');
    const groupedRecords = students.detailed_records?.reduce((acc, record) => {
        const studentId = record.student_uuid;

        // Initialize the student record if not already present
        if (!acc[studentId]) {
            acc[studentId] = {
                profile_pic: record.profile_pic,
                student_status: record.student_status,
                student_uuid: record.student_uuid,
                first_name: record.first_name,
                moeis_name: record.moeis_name,
                is_twin: record.is_twin || 0,
                attendance: [], // Store attendance details
            };
        }

        // Only include records matching the selected date
        if (record.date === formattedSelectedDate) {
            acc[studentId].attendance.push({
                profile_pic: record.profile_pic,
                student_status: record.student_status,
                date: record.date,
                status: record.status,
                check_in_time: record.check_in_time,
                check_in_gate: record.check_in_gate,
                check_out_time: record.check_out_time,
                check_out_gate: record.check_out_gate,
                check_in_image_url: record.check_in_image_url || null,
                check_out_image_url: record.check_out_image_url || null,
                letter_attachment_url: record.letter_attachment_url || null,
                attachment_url: record.attachment_url || null,
                happy_percentage_rate: record.happy_percentage_rate || 0,
                remarks: record.remarks,
                latitude: record.latitude || null,
                longitude: record.longitude || null,
                is_twin: record.is_twin || 0
            });
        }

        return acc;
    }, {}) || {};

    const notifyParent = async (studentUuid) => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        try {
            const response = await API.post(
                `/attendance/notifyParent`,
                JSON.stringify({ student_id: studentUuid }), // Pass the student UUID and date
                { headers }
            );

            if (response.data.response_code === 1000) {
                toast.success("Waris berjaya dimaklumkan", { autoClose: 5000 });
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {

            toast.error("Ralat memaklumkan waris", { autoClose: 5000 });
        }
    };
    const openUpdateClassModal = (student) => {
        setSelectedStudent(student);
        setModalOpen(true);
    };
    const closeModal = () => {
        setSelectedStudent(null);
        setNewClassId('');
        setModalOpen(false);
    };
    // 2. getMCReasons function INSIDE your component
    const getMCReasons = async () => {
        const url = "https://api.schoolpay.tech/attendance/absenceReason";
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            const responseJSON = await response.json();

            if (responseJSON.response_code === 1000) {
                const reasons = responseJSON.data.map((reason) => ({
                    label: reason.name + (reason.sub_reason ? " - " + reason.sub_reason : ""),
                    value: reason.reason_id,
                }));
                setMCReasons(reasons);
            } else {
                console.error("Gagal mendapatkan sebab tidak hadir:", responseJSON.message);
            }
        } catch (error) {
            console.error("Ralat mendapatkan sebab tidak hadir:", error);
        }
    };
    const updateStudentClass = async () => {
        if (!selectedStudent || !newClassId) {
            toast.error("Sila pilih jabatan baharu.", { autoClose: 5000 });
            return;
        }

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        try {
            const response = await API.post(
                `/portal/modifyClass`,
                { student_id: selectedStudent.student_uuid, new_class_id: newClassId },
                { headers }
            );
            if (response.data.response_code === 1000) {
                toast.success("Jabatan pegawai berjaya dikemaskini!", { autoClose: 5000 });
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
                closeModal();
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {
            console.error('Error updating student class:', error);
            toast.error("Ralat mengemaskini jabatan pegawai", { autoClose: 5000 });
        }
    };
    const submitManualAttendance = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        let payload = {
            class_id: classId,
            student_uuid: selectedStudent.student_uuid,
            start_date: recordStartDate,
            end_date: recordEndDate || recordStartDate,
            status: Number(recordStatus),
        };

        if (Number(recordStatus) === 0) {
            // MC required for Absent
            if (!selectedMCReason) {
                toast.error("Sila pilih sebab tidak hadir / MC.", { autoClose: 5000 });
                return;
            }
            payload.remarks = selectedMCReason.label;
            payload.reason_type = selectedMCReason.value;
        } else {
            // Remarks for present, but NOT MC reason!
            payload.remarks = recordRemarks;
            payload.reason_type = "";
        }
        setLoading(true);
        try {
            const response = await API.post('/attendance/teacher/record', payload, { headers });
            if (response.data.response_code === 1000) {
                toast.success(response.data.message, { autoClose: 5000 });
                setRecordModalOpen(false);
                fetchStudentsAttendanceDetail(selectedDate);
                fetchStudentsAttendanceSummary(selectedDate);
            } else {
                toast.error(response.data.message, { autoClose: 5000 });
            }
        } catch (error) {

            toast.error(error.message, { autoClose: 5000 });

        } finally {
            setLoading(false);
        }
    };
    const openConfirmPresentModal = () => {
        const unrecordedStudents = Object.values(groupedRecords).filter(student =>
            student.attendance.some(att => att.status === '0' || att.status === 'unrecorded')
        );

        if (unrecordedStudents.length === 0) {
            toast.info("Tiada pegawai belum direkod untuk dikemaskini.", { autoClose: 5000 });
            return;
        }

        setUnrecordedList(unrecordedStudents);
        setConfirmPresentModalOpen(true);
    };

    const removeFromUnrecordedList = (studentId) => {
        setUnrecordedList(prev => prev.filter(s => s.student_uuid !== studentId));
    };
    const openConfirmAbsentModal = () => {
        const unrecordedStudents = Object.values(groupedRecords).filter(student =>
            student.attendance.some(att => att.status === '0' || att.status === 'unrecorded')
        );

        if (unrecordedStudents.length === 0) {
            toast.info("Tiada pegawai belum direkod untuk ditanda tidak hadir.", { autoClose: 5000 });
            return;
        }

        setUnrecordedList(unrecordedStudents);
        setConfirmAbsentModalOpen(true);
    };
    const confirmMarkAllAsAbsent = async () => {
        if (!startBulkDate || !endBulkDate) {
            return alert("Sila pilih tarikh mula dan tarikh tamat.");
        }

        if (!selectedBulkMCReason) {
            toast.error("Sila pilih sebab tidak hadir terlebih dahulu.", { autoClose: 4000 });
            return;
        }

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        const start = dayjs(startBulkDate);
        const end = dayjs(endBulkDate);
        const daysDiff = end.diff(start, 'day');

        if (daysDiff < 0) {
            return toast.error("Tarikh mula tidak boleh selepas tarikh tamat.", { autoClose: 4000 });
        }

        setLoading(true);

        try {
            const requests = [];

            for (let i = 0; i <= daysDiff; i++) {
                const date = start.add(i, 'day').format("YYYY-MM-DD");

                unrecordedList.forEach(student => {
                    const payload = {
                        class_id: classId,
                        student_uuid: student.student_uuid,
                        start_date: date,
                        end_date: date,
                        status: 0,
                        remarks: selectedBulkMCReason.label,
                        reason_type: selectedBulkMCReason.value,
                    };
                    requests.push(API.post("/attendance/teacher/record", payload, { headers }));
                });
            }

            await Promise.all(requests);

            toast.success("Semua pegawai belum direkod telah ditanda sebagai tidak hadir untuk tarikh yang dipilih.", { autoClose: 4000 });

            // Refresh UI
            fetchStudentsAttendanceDetail(selectedDate);
            fetchStudentsAttendanceSummary(selectedDate);
            setConfirmAbsentModalOpen(false);
            setSelectedBulkMCReason(null);
            setStartBulkDate("");
            setEndBulkDate("");
        } catch (error) {
            console.error("Error marking absent:", error);
            toast.error("Gagal menanda tidak hadir.", { autoClose: 4000 });
        } finally {
            setLoading(false);
        }
    };
    const [subjects, setSubjects] = useState([]);

    const fetchSubjects = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await API.get("/timetable/subjects", {
                headers: { token, is_portal: true }
            });
            if (res.data.response_code === 1000) {
                setSubjects(
                    res.data.data.map(s => ({
                        label: s.subject_name,
                        value: s.subject_name
                    }))
                );
            }
        } catch (err) {
            console.error("Subjects error:", err);
        }
    };

    // run on mount
    useEffect(() => {
        fetchSubjects();
    }, []);


    const HappinessBadge = ({ value }) => {
        if (value === null || value === undefined || value === 0) {
            return null;
        }

        let color = "#6c757d";
        let bg = "#f1f3f5";
        let emoji = "😐";

        if (value >= 40) {
            bg = "#e6f4ea";
            color = "#2e7d32";
            emoji = "😊";
        } else if (value >= 25) {
            bg = "#fff8e1";
            color = "#f57f17";
            emoji = "🙂";
        } else {
            bg = "#ffebee";
            color = "#c62828";
            emoji = "😕";
        }

        return (
            <span
                style={{
                    marginVertical: 4,
                    background: bg,
                    color,
                    padding: "4px 10px",
                    borderRadius: "14px",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6
                }}
            >
                Happiness: {emoji} {value}%
            </span>
        );
    };

    return (
        <Fragment>
            <style>{`

                .modern-modal-backdrop {
                    position: fixed;
                    inset: 0;
                    z-index: 9999;
                    background: rgba(15, 23, 42, 0.58);
                    backdrop-filter: blur(6px);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 18px;
                }

                .modern-modal-card {
                    width: min(640px, 100%);
                    max-height: 92vh;
                    background: #ffffff;
                    border-radius: 26px;
                    overflow: hidden;
                    box-shadow: 0 28px 80px rgba(15, 23, 42, 0.34);
                    border: 1px solid rgba(226, 232, 240, 0.9);
                    animation: modalPop 0.18s ease-out;
                }

                .modern-modal-lg {
                    width: min(920px, 100%);
                }

                .modern-modal-md {
                    width: min(640px, 100%);
                }

                .modern-modal-sm {
                    width: min(460px, 100%);
                }

                @keyframes modalPop {
                    from {
                        opacity: 0;
                        transform: translateY(12px) scale(0.98);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0) scale(1);
                    }
                }

                .modern-modal-header {
                    padding: 22px 24px;
                    color: #ffffff;
                    background: linear-gradient(135deg, #0B4C9C 0%, #0F65C9 60%, #1E88E5 100%);
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    gap: 18px;
                    position: relative;
                    overflow: hidden;
                }

                .modern-modal-header::after {
                    content: "";
                    position: absolute;
                    right: -60px;
                    top: -80px;
                    width: 190px;
                    height: 190px;
                    border-radius: 999px;
                    background: rgba(255, 255, 255, 0.12);
                }

                .modern-modal-title-wrap {
                    position: relative;
                    z-index: 1;
                    min-width: 0;
                }

                .modern-modal-kicker {
                    font-size: 11px;
                    font-weight: 900;
                    letter-spacing: 0.12em;
                    text-transform: uppercase;
                    color: rgba(255, 255, 255, 0.72);
                    margin-bottom: 6px;
                }

                .modern-modal-title {
                    margin: 0;
                    color: #ffffff;
                    font-size: 20px;
                    font-weight: 900;
                    line-height: 1.25;
                    letter-spacing: -0.02em;
                    overflow-wrap: anywhere;
                }

                .modern-modal-close {
                    width: 38px;
                    height: 38px;
                    border: 1px solid rgba(255, 255, 255, 0.22);
                    border-radius: 14px;
                    background: rgba(255, 255, 255, 0.12);
                    color: #ffffff;
                    font-size: 24px;
                    line-height: 1;
                    cursor: pointer;
                    position: relative;
                    z-index: 2;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .modern-modal-close:hover {
                    background: rgba(255, 255, 255, 0.22);
                }

                .modern-modal-body {
                    padding: 24px;
                    max-height: calc(92vh - 150px);
                    overflow-y: auto;
                    background: #ffffff;
                }

                .modern-modal-body .form-control {
                    border-radius: 13px;
                    border-color: #bfdbfe;
                    min-height: 42px;
                    font-weight: 600;
                }

                .modern-modal-body .form-control:focus {
                    border-color: #0B4C9C;
                    box-shadow: 0 0 0 4px rgba(11, 76, 156, 0.08);
                }

                .modern-modal-body label {
                    font-size: 13px;
                    font-weight: 800;
                    color: #0f172a;
                    margin-bottom: 7px;
                }

                .modern-modal-body .form-group {
                    margin-bottom: 14px;
                }

                .modern-modal-footer {
                    padding: 16px 24px;
                    background: #f8fafc;
                    border-top: 1px solid #e2e8f0;
                    display: flex;
                    justify-content: flex-end;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .modern-modal-body .table {
                    border-color: #dbeafe;
                }

                .modern-modal-body .table th {
                    background: #eff6ff;
                    color: #0B4C9C;
                    font-weight: 900;
                    font-size: 13px;
                }

                @media (max-width: 575px) {
                    .modern-modal-card {
                        border-radius: 20px;
                    }

                    .modern-modal-header,
                    .modern-modal-body,
                    .modern-modal-footer {
                        padding: 18px;
                    }

                    .modern-modal-footer {
                        flex-direction: column-reverse;
                    }

                    .modern-modal-footer button {
                        width: 100%;
                    }
                }

                .department-profile-page { background: linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%); min-height: 100vh; padding: 22px; }
                .department-profile-page .card { border: 1px solid #dbeafe; border-radius: 22px; box-shadow: 0 18px 45px rgba(11, 76, 156, 0.10); overflow: hidden; }
                .department-profile-page .card-header { background: linear-gradient(135deg, #0B4C9C 0%, #0F65C9 55%, #1E88E5 100%); color: #ffffff; border-bottom: none; }
                .department-profile-page .btn-primary { background-color: #0B4C9C; border-color: #0B4C9C; }
                .department-profile-page .btn-success { background-color: #ECFDF5; border-color: #A7F3D0; color: #047857; }
                .department-profile-page .btn-danger { background-color: #FEF2F2; border-color: #FECACA; color: #B91C1C; }
                .department-profile-page .btn-outline-warning { background-color: #EFF6FF; border-color: #BFDBFE; color: #0B4C9C; }
                .department-profile-page .btn-outline-danger { background-color: #FEF2F2; border-color: #FECACA; color: #B91C1C; }
                .department-profile-page .btn-outline-primary { color: #0B4C9C; border-color: #0B4C9C; }
                .department-profile-page .btn-outline-primary:hover { background-color: #0B4C9C; color: #ffffff; }
                .department-profile-page .nav-tabs .nav-link.active { color: #0B4C9C; font-weight: 800; border-top: 3px solid #0B4C9C; }
                .department-profile-page table th { background: #eff6ff; color: #0B4C9C; font-weight: 900; font-size: 13px; }
                .department-profile-page table td { font-size: 14px; vertical-align: top; }
                .calendar-modern .react-calendar { width: 100%; border: 1px solid #dbeafe; border-radius: 18px; padding: 14px; box-shadow: 0 10px 25px rgba(11,76,156,0.08); }
                .calendar-modern .react-calendar__tile--active { background: #0B4C9C !important; color: #ffffff !important; border-radius: 10px; }
                .glow-circle { width: 22px; height: 22px; border-radius: 50%; background: #0B4C9C; box-shadow: 0 0 0 8px rgba(11,76,156,0.18), 0 0 22px rgba(11,76,156,0.45); }

                .department-profile-page .action-toolbar {
                    display: flex;
                    gap: 10px;
                    flex-wrap: wrap;
                    align-items: center;
                }
                .department-profile-page .gov-btn,
                .department-profile-page .btn.gov-btn {
                    min-height: 38px !important;
                    border-radius: 12px !important;
                    padding: 9px 14px !important;
                    font-size: 12px !important;
                    font-weight: 800 !important;
                    letter-spacing: 0.01em !important;
                    display: inline-flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    gap: 7px !important;
                    border: 1px solid transparent !important;
                    box-shadow: none !important;
                    transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.16s ease !important;
                    white-space: nowrap !important;
                }
                .department-profile-page .gov-btn:hover,
                .department-profile-page .btn.gov-btn:hover {
                    transform: translateY(-1px) !important;
                }
                .department-profile-page .gov-btn:disabled,
                .department-profile-page .btn.gov-btn:disabled {
                    opacity: 0.55 !important;
                    cursor: not-allowed !important;
                    transform: none !important;
                }
                .department-profile-page .gov-btn-primary,
                .department-profile-page .btn.gov-btn-primary {
                    background: linear-gradient(135deg, #0B4C9C 0%, #0F65C9 100%) !important;
                    color: #ffffff !important;
                    border-color: #0B4C9C !important;
                }
                .department-profile-page .gov-btn-primary:hover,
                .department-profile-page .btn.gov-btn-primary:hover {
                    background: linear-gradient(135deg, #083D7E 0%, #0B4C9C 100%) !important;
                    color: #ffffff !important;
                }
                .department-profile-page .gov-btn-outline,
                .department-profile-page .btn.gov-btn-outline {
                    background: #ffffff !important;
                    color: #0B4C9C !important;
                    border-color: #BFD7F5 !important;
                }
                .department-profile-page .gov-btn-outline:hover,
                .department-profile-page .btn.gov-btn-outline:hover {
                    background: #EFF6FF !important;
                    color: #083D7E !important;
                    border-color: #0B4C9C !important;
                }
                .department-profile-page .gov-btn-soft,
                .department-profile-page .btn.gov-btn-soft {
                    background: #EFF6FF !important;
                    color: #0B4C9C !important;
                    border-color: #BFDBFE !important;
                }
                .department-profile-page .gov-btn-soft:hover,
                .department-profile-page .btn.gov-btn-soft:hover {
                    background: #DBEAFE !important;
                    color: #083D7E !important;
                    border-color: #93C5FD !important;
                }
                .department-profile-page .gov-btn-success,
                .department-profile-page .btn.gov-btn-success {
                    background: #ECFDF5 !important;
                    color: #047857 !important;
                    border-color: #A7F3D0 !important;
                }
                .department-profile-page .gov-btn-success:hover,
                .department-profile-page .btn.gov-btn-success:hover {
                    background: #D1FAE5 !important;
                    color: #065F46 !important;
                    border-color: #6EE7B7 !important;
                }
                .department-profile-page .gov-btn-danger,
                .department-profile-page .btn.gov-btn-danger {
                    background: #FEF2F2 !important;
                    color: #B91C1C !important;
                    border-color: #FECACA !important;
                }
                .department-profile-page .gov-btn-danger:hover,
                .department-profile-page .btn.gov-btn-danger:hover {
                    background: #FEE2E2 !important;
                    color: #991B1B !important;
                    border-color: #FCA5A5 !important;
                }
                .department-profile-page .gov-btn-neutral,
                .department-profile-page .btn.gov-btn-neutral {
                    background: #F8FAFC !important;
                    color: #334155 !important;
                    border-color: #E2E8F0 !important;
                }
                .department-profile-page .gov-btn-neutral:hover,
                .department-profile-page .btn.gov-btn-neutral:hover {
                    background: #F1F5F9 !important;
                    color: #0F172A !important;
                    border-color: #CBD5E1 !important;
                }
                .department-profile-page .row-action-stack {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    min-width: 160px;
                }

                .department-profile-page .modal-footer .btn,
                .department-profile-page .modal-body .btn,
                .department-profile-page .list-group .btn {
                    border-radius: 12px !important;
                    font-weight: 800 !important;
                    box-shadow: none !important;
                }
                .department-profile-page .btn-link.gov-btn-link {
                    color: #0B4C9C !important;
                    text-decoration: none !important;
                    font-weight: 800 !important;
                    padding: 8px 10px !important;
                    border-radius: 10px !important;
                }
                .department-profile-page .btn-link.gov-btn-link:hover {
                    background: #EFF6FF !important;
                    color: #083D7E !important;
                }
                .department-profile-page .archive-icon-soft {
                    width: 40px;
                    height: 40px;
                    background: #EFF6FF !important;
                    color: #0B4C9C !important;
                }
                @media (max-width: 768px) {
                    .department-profile-page .action-toolbar,
                    .department-profile-page .row-action-stack {
                        width: 100%;
                    }
                    .department-profile-page .gov-btn,
                    .department-profile-page .btn.gov-btn {
                        width: 100% !important;
                    }
                }
            `}</style>
            <div className="container-fluid department-profile-page">
                <div className="row">
                    <div className='row gx-0'>
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-2">
                                    <h4 className="mb-0 flex-grow-1">Jabatan / Unit {className}</h4>

                                    <div className="action-toolbar">
                                        <button
                                            className="btn gov-btn gov-btn-soft"
                                            onClick={openArchiveModal}
                                        >
                                            <i className="fa fa-archive"></i> Arkib Semua Pegawai
                                        </button>
                                        <button
                                            className="btn gov-btn gov-btn-primary"
                                            onClick={() => setRegisterModalOpen(true)}
                                        >
                                            + Daftar Pegawai
                                        </button>

                                        <button
                                            className="btn gov-btn gov-btn-success"
                                            onClick={openConfirmPresentModal}
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    Sedang Diproses...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-check2-circle"></i>
                                                    Tanda Semua Belum Direkod Sebagai Hadir
                                                </>
                                            )}
                                        </button>
                                        <button
                                            className="btn gov-btn gov-btn-danger"
                                            onClick={openConfirmAbsentModal}
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    Sedang Diproses...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-x-circle"></i>
                                                    Tanda Semua Sebagai Tidak Hadir
                                                </>
                                            )}
                                        </button>

                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="calendar-modern">
                                        <Calendar
                                            value={selectedDate}

                                            onChange={(date) => {
                                                setSelectedDate(date);
                                                setStartBulkDate(dayjs(date).format('YYYY-MM-DD'));
                                                setEndBulkDate(dayjs(date).format('YYYY-MM-DD'));
                                            }}
                                            onActiveStartDateChange={({ activeStartDate }) => {
                                                setActiveMonthDate(activeStartDate);
                                            }}
                                            tileContent={tileContent}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Nav tabs className="mt-3">
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeSubTab === "students" })}
                                onClick={() => toggleSubTab("students")}
                                style={{ cursor: "pointer" }}
                            >
                                Senarai Pegawai
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeSubTab === "timetable" })}
                                onClick={() => toggleSubTab("timetable")}
                                style={{ cursor: "pointer" }}
                            >
                                Timetable
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeSubTab} className="border-start border-end border-bottom p-3">
                        <TabPane tabId="students">
                            <div className="card-body">

                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }} />
                                        <h6 className="fw-semibold text-muted">Sedang Memuatkan...</h6>
                                        <small className="text-gray">Sila tunggu sementara data dimuatkan.</small>
                                    </div>

                                ) : groupedRecords && Object.keys(groupedRecords).length > 0 ? (
                                    <>
                                        <div style={{
                                            width: "100%",
                                            overflowX: "auto",
                                            WebkitOverflowScrolling: "touch",
                                            marginTop: "1rem",
                                        }}>
                                            <Table bordered responsive hover style={{ width: '100%', tableLayout: "auto" }}>
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Profil</th>
                
                                                        <th>Rekod Masa</th>
                                                        <th>Makluman</th>
                                                        <th>Tindakan</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {Object.values(groupedRecords).map((student, index) => (
                                                        <tr key={student.student_uuid}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <div className="d-flex flex-column">
                                                                        {student.profile_pic ? (
                                                                            <img
                                                                                src={student.profile_pic}
                                                                                alt={`${student.first_name}'s Profile`}
                                                                                style={{
                                                                                    width: '48px',
                                                                                    height: '48px',
                                                                                    borderRadius: '50%',
                                                                                    objectFit: 'cover',
                                                                                    boxShadow: '0 0 4px rgba(0,0,0,0.1)',
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <div
                                                                                style={{
                                                                                    width: '48px',
                                                                                    height: '48px',
                                                                                    borderRadius: '50%',
                                                                                    background: '#e9ecef',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    fontWeight: 'bold',
                                                                                    color: '#6c757d',
                                                                                }}
                                                                            >
                                                                                {student.first_name?.[0]?.toUpperCase() || '?'}
                                                                            </div>
                                                                        )}

                                                                    </div>

                                                                    <div className="d-flex flex-column">
                                                                        <div>
                                                                            <span className="fw-semibold text-dark me-1">{student.first_name}</span>

                                                                        </div>

                                                                        <div>
                                                                            <button
                                                                                className="btn gov-btn gov-btn-outline mt-1"
                                                                                onClick={() => openNameModal(student)}
                                                                            >
                                                                                Update Name
                                                                            </button>
                                                                        </div>


                                                                    </div>


                                                                </div>
                                                            </td>

                                                            <td>
                                                                {/* Render statuses for the student */}
                                                                {student.attendance.map((att, i) => (
                                                                    <div
                                                                        key={i}
                                                                        className="mb-2"
                                                                        style={{
                                                                            display: 'inline-block',
                                                                            padding: '5px 10px',
                                                                            borderRadius: '12px',
                                                                            fontWeight: 'bold',
                                                                            backgroundColor: att.status == '0'
                                                                                ? '#f8d7da' // Light red for background (Absent)
                                                                                : att.status == '1'
                                                                                    ? '#d4edda' // Light green for background (Check-in)
                                                                                    : att.status == '2'
                                                                                        ? '#d1ecf1' // Light blue for background (Check-out)
                                                                                        : '#f8f9fa', // Light gray for background (Unrecorded)
                                                                            color: att.status == '0'
                                                                                ? '#721c24' // Dark red for text (Absent)
                                                                                : att.status == '1'
                                                                                    ? '#155724' // Dark green for text (Check-in)
                                                                                    : att.status == '2'
                                                                                        ? '#0c5460' // Dark blue for text (Check-out)
                                                                                        : '#6c757d', // Dark gray for text (Unrecorded)
                                                                        }}
                                                                    >
                                                                        {att.status == '0'
                                                                            ? 'Tidak Hadir'
                                                                            : att.status == '1'
                                                                                ? 'Check-in'
                                                                                : att.status == '2'
                                                                                    ? 'Keluar'
                                                                                    : 'Belum Hadir'}
                                                                    </div>

                                                                ))}
                                                            </td>
                                                            <td>
                                                                <div style={{ position: 'relative', paddingLeft: '30px', borderLeft: '3px solid #28A745', margin: '15px 0 15px 15px' }}>
                                                                    {student.attendance
                                                                        .filter(att => att.status !== 'unrecorded')
                                                                        .map((att, i) => {
                                                                            const duration = att.check_in_time && att.check_out_time
                                                                                ? moment.duration(moment.unix(att.check_out_time).diff(moment.unix(att.check_in_time))).humanize()
                                                                                : null;

                                                                            return (
                                                                                <div key={i} style={{ position: 'relative', marginBottom: '40px' }}>
                                                                                    {/* Timeline Green Dot */}
                                                                                    <div style={{
                                                                                        position: 'absolute', left: '-39px', top: '0',
                                                                                        width: '16px', height: '16px', backgroundColor: '#28A745',
                                                                                        borderRadius: '50%', border: '3px solid white', boxShadow: '0 0 0 2px #28A745'
                                                                                    }}></div>

                                                                                    <div className="row g-4">
                                                                                        {/* LEFT COLUMN: Logistics & Status */}
                                                                                        <div className="col-md-3">
                                                                                            <div className="d-flex flex-column gap-2">
                                                                                                <div style={{ backgroundColor: '#f0fff4', padding: '12px', borderRadius: '12px', border: '1px solid #d1fae5' }}>
                                                                                                    {att.check_in_time && (
                                                                                                        <div className="mb-2">
                                                                                                            <small className="text-uppercase fw-bold text-muted" style={{ fontSize: '9px', letterSpacing: '0.5px' }}>Masuk</small>
                                                                                                            <div className="fw-bold text-success" style={{ fontSize: '1rem' }}>{moment.unix(att.check_in_time).format('hh:mm A')}</div>
                                                                                                            <div className="small text-dark opacity-75">Lokasi {att.check_in_gate}</div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                    {att.check_out_time && (
                                                                                                        <div className="pt-2 border-top border-success border-opacity-10">
                                                                                                            <small className="text-uppercase fw-bold text-muted" style={{ fontSize: '9px', letterSpacing: '0.5px' }}>Keluar</small>
                                                                                                            <div className="fw-bold text-success" style={{ fontSize: '1rem' }}>{moment.unix(att.check_out_time).format('hh:mm A')}</div>
                                                                                                            <div className="small text-dark opacity-75">Lokasi {att.check_out_gate}</div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                                <HappinessBadge value={att.happy_percentage_rate} />
                                                                                                {duration && (
                                                                                                    <div className="mt-1 text-center py-1 bg-light rounded border border-dashed">
                                                                                                        <small className="text-muted small">Tempoh: <strong>{duration}</strong></small>
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* RIGHT COLUMN: Media & Map */}
                                                                                        <div className="col-md-9">
                                                                                            <div className="d-flex flex-wrap align-items-start gap-3">
                                                                                                {/* PHOTOS WITH HOVER ZOOM */}
                                                                                                {[
                                                                                                    { url: att.check_in_image_url, label: 'Gambar Masuk' },
                                                                                                    { url: att.check_out_image_url, label: 'Gambar Keluar' }
                                                                                                ].map((img, idx) => img.url && (
                                                                                                    <div key={idx} className="text-center" style={{ perspective: '1000px' }}>
                                                                                                        <div style={{
                                                                                                            overflow: 'hidden', borderRadius: '12px',
                                                                                                            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                                                                                            transition: 'all 0.3s ease-in-out', cursor: 'zoom-in',
                                                                                                        }}
                                                                                                            onMouseEnter={(e) => {
                                                                                                                e.currentTarget.style.transform = 'scale(1.5) translateY(-10px)';
                                                                                                                e.currentTarget.style.zIndex = '100';
                                                                                                            }}
                                                                                                            onMouseLeave={(e) => {
                                                                                                                e.currentTarget.style.transform = 'scale(1) translateY(0)';
                                                                                                                e.currentTarget.style.zIndex = '1';
                                                                                                            }}
                                                                                                        >
                                                                                                            <img src={img.url} style={{ width: '160px', height: '160px', objectFit: 'cover', display: 'block' }} />
                                                                                                        </div>
                                                                                                        <small className="d-block text-muted mt-2 fw-bold" style={{ fontSize: '10px' }}>{img.label}</small>
                                                                                                    </div>
                                                                                                ))}
                                                                                                {/* NEW DEDICATED REMARKS BLOCK */}
                                                                                                {att.remarks && (
                                                                                                    <div className="mt-0" style={{
                                                                                                        backgroundColor: '#fffbeb',
                                                                                                        border: '1px solid #fde68a',
                                                                                                        borderRadius: '12px',
                                                                                                        padding: '12px 16px',
                                                                                                        position: 'relative'
                                                                                                    }}>


                                                                                                        <div className="d-flex gap-2">
                                                                                                            <span style={{ fontSize: '1.2rem' }}>📝</span>
                                                                                                            <div>
                                                                                                                <small className="fw-bold text-warning d-block" style={{ fontSize: '10px', textTransform: 'uppercase' }}>Catatan</small>
                                                                                                                <div className="text-dark" style={{ fontSize: '13px' }}>{att.remarks}</div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                                {/* MAP */}
                                                                                                {att.latitude && att.longitude && (
                                                                                                    <div style={{ flex: '1', minWidth: '250px', height: '200px', borderRadius: '12px', overflow: 'hidden', border: '1px solid #dee2e6', transition: 'all 0.4s ease', position: 'relative' }}>
                                                                                                        <MapContainer center={[att.latitude, att.longitude]} zoom={17} scrollWheelZoom={true} style={{ height: "100%", width: "100%" }}>
                                                                                                            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                                                                                            <Marker position={[att.latitude, att.longitude]} icon={glowingIcon} />
                                                                                                        </MapContainer>
                                                                                                        <div style={{ position: 'absolute', top: 5, right: 5, background: 'rgba(40, 167, 69, 0.9)', color: 'white', padding: '2px 8px', borderRadius: '5px', fontSize: '9px', zIndex: 1000 }}>LOKASI</div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>



                                                                                            {/* ACTION BUTTONS MOVED BELOW REMARKS */}
                                                                                            <div className="d-flex gap-2 mt-3">
                                                                                                {att.status === '0' && (
                                                                                                    <>
                                                                                                        {att.letter_attachment_url && (
                                                                                                            <button className="btn gov-btn gov-btn-outline" onClick={() => window.open(att.letter_attachment_url, '_blank')}>Lihat Surat</button>
                                                                                                        )}
                                                                                                        {att.attachment_url && (
                                                                                                            <button className="btn gov-btn gov-btn-primary" onClick={() => window.open(att.attachment_url, '_blank')}>Lihat MC</button>
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className="row-action-stack">
                                                                    <button
                                                                        className="btn gov-btn gov-btn-outline"
                                                                        style={{
                                                                            backgroundColor: 'white',
                                                                            color: '#0B4C9C',
                                                                            border: '2px solid #0B4C9C',
                                                                            padding: '8px 16px',
                                                                            borderRadius: '12px',
                                                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                                            fontWeight: '600',
                                                                            transition: 'all 0.3s ease',
                                                                        }}
                                                                        onClick={() => openRecordAttendanceModal(student)}
                                                                    >
                                                                        Rekod Kehadiran
                                                                    </button>
                                                                    <button
                                                                        className="btn gov-btn gov-btn-outline"
                                                                        style={{
                                                                            backgroundColor: 'white',
                                                                            color: '#0B4C9C',
                                                                            border: '2px solid #0B4C9C',
                                                                            padding: '8px 16px',
                                                                            borderRadius: '12px',
                                                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                                            fontWeight: '600',
                                                                            transition: 'all 0.3s ease',
                                                                        }}
                                                                        onClick={() => openUpdateClassModal(student)}
                                                                    >
                                                                        Tukar Jabatan
                                                                    </button>
                                                                    <button
                                                                        className="btn gov-btn gov-btn-danger"
                                                                        style={{
                                                                            background: 'rgba(11,76,156,0.09)',
                                                                            color: '#0B4C9C',
                                                                            border: '2px solid #0B4C9C',
                                                                            padding: '8px 18px',
                                                                            borderRadius: '24px',
                                                                            fontWeight: 700,
                                                                            letterSpacing: '0.02em',
                                                                            boxShadow: '0 3px 8px rgba(11,76,156,0.13)',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: 7,
                                                                            transition: 'all 0.18s',
                                                                            backdropFilter: 'blur(3px)',
                                                                            cursor:
                                                                                student.student_status === '0' ||
                                                                                    student.student_status === '2' ||
                                                                                    student.student_status === '3' ||
                                                                                    student.student_status === '4'
                                                                                    ? 'pointer'
                                                                                    : 'not-allowed',
                                                                            opacity:
                                                                                student.student_status === '0' ||
                                                                                    student.student_status === '2' ||
                                                                                    student.student_status === '3' ||
                                                                                    student.student_status === '4'
                                                                                    ? 1
                                                                                    : 0.45,
                                                                        }}
                                                                        onClick={() => openDeleteModal(student)}
                                                                        disabled={
                                                                            !(
                                                                                student.student_status === '0' ||
                                                                                student.student_status === '2' ||
                                                                                student.student_status === '3' ||
                                                                                student.student_status === '4'
                                                                            )
                                                                        }
                                                                        onMouseOver={e => {
                                                                            if (
                                                                                student.student_status === '0' ||
                                                                                student.student_status === '2' ||
                                                                                student.student_status === '3' ||
                                                                                student.student_status === '4'
                                                                            ) {
                                                                                e.currentTarget.style.background =
                                                                                    'linear-gradient(90deg, #0B4C9C 0%, #0F65C9 100%)';
                                                                                e.currentTarget.style.color = 'white';
                                                                            }
                                                                        }}
                                                                        onMouseOut={e => {
                                                                            if (
                                                                                student.student_status === '0' ||
                                                                                student.student_status === '2' ||
                                                                                student.student_status === '3' ||
                                                                                student.student_status === '4'
                                                                            ) {
                                                                                e.currentTarget.style.background = 'rgba(11,76,156,0.09)';
                                                                                e.currentTarget.style.color = '#0B4C9C';
                                                                            }
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            width="20"
                                                                            height="20"
                                                                            fill="none"
                                                                            stroke="currentColor"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            style={{ marginRight: 3 }}
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <polyline points="3 6 5 6 21 6" />
                                                                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
                                                                            <line x1="10" y1="11" x2="10" y2="17" />
                                                                            <line x1="14" y1="11" x2="14" y2="17" />
                                                                        </svg>
                                                                        Padam Pegawai
                                                                    </button>
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>

                                    </>

                                ) : (
                                    <div className="text-center py-5">
                                        <h6 className="text-muted mb-2">Tiada rekod pegawai untuk tarikh ini</h6>
                                        <small className="text-gray">Sila pilih tarikh lain pada kalendar.</small>
                                    </div>
                                )}

                            </div>
                        </TabPane>
                        <TabPane tabId="timetable" fade={false}>
                            <TimetableTab
                                selectedDay={selectedDay}
                                setSelectedDay={setSelectedDay}
                                loadingTimetable={loadingTimetable}
                                filteredTimetable={filteredTimetable}
                                openAddModal={() => setAddModalOpen(true)}  // opens the modal
                                teachers={teachers}
                            />
                        </TabPane>

                    </TabContent>

                </div>
                <Modal isOpen={confirmPresentModalOpen} toggle={() => setConfirmPresentModalOpen(false)}>
                    <ModalHeader toggle={() => setConfirmPresentModalOpen(false)}>
                        Sahkan Semua Hadir
                    </ModalHeader>
                    <ModalBody>
                        <p>Pegawai berikut akan ditanda sebagai <b>Hadir</b>:</p>
                        <Table bordered hover responsive>
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Profil</th>
                                    <th style={{ width: "55%", minWidth: "200px" }}>Nama</th>
                                    <th style={{ width: "25%" }}>Tindakan</th>
                                </tr>
                            </thead>
                            <tbody>
                                {unrecordedList.map((s, idx) => (
                                    <tr key={s.student_uuid}>
                                        <td>{idx + 1}</td>
                                        <td>
                                            {s.profile_pic ? (
                                                <img
                                                    src={s.profile_pic}
                                                    alt={s.first_name}
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "50%",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            ) : (
                                                <span className="text-muted">N/A</span>
                                            )}
                                        </td>
                                        <td className="fw-semibold">{s.moeis_name}</td>
                                        <td>
                                            <Button
                                                className="gov-btn gov-btn-danger"
                                                size="sm"
                                                onClick={() => removeFromUnrecordedList(s.student_uuid)}
                                            >
                                                Buang
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                    </ModalBody>
                    <ModalFooter>
                        <Button className="gov-btn gov-btn-success" onClick={confirmMarkAllAsPresent} disabled={loading}>
                            {loading ? "Sedang Diproses..." : "Confirm"}
                        </Button>
                        <Button className="gov-btn gov-btn-neutral" onClick={() => setConfirmPresentModalOpen(false)}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>

                {/* Modal for Updating Class */}
                <Modal isOpen={modalOpen} toggle={closeModal}>
                    <ModalHeader toggle={closeModal}>Tukar Jabatan Pegawai</ModalHeader>
                    <ModalBody>
                        <select
                            className="form-control"
                            value={newClassId}
                            onChange={(e) => setNewClassId(e.target.value)}
                        >
                            <option value="">Pilih jabatan baharu</option>
                            {allClasses.map((cls) => (
                                <option key={cls.class_id} value={cls.class_id}>
                                    {cls.class_name}
                                </option>
                            ))}
                        </select>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="gov-btn gov-btn-primary" onClick={updateStudentClass}>Kemaskini</Button>
                        <Button className="gov-btn gov-btn-neutral" onClick={closeModal}>Batal</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={nameModalOpen} toggle={closeNameModal}>
                    <ModalHeader toggle={closeNameModal}>Kemaskini Nama Pegawai</ModalHeader>
                    <ModalBody>
                        <input
                            type="text"
                            className="form-control"
                            value={newStudentName}
                            onChange={(e) => setNewStudentName(e.target.value)}
                            placeholder="Masukkan nama pegawai baharu"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button className="gov-btn gov-btn-primary" onClick={updateStudentName}>Kemaskini</Button>
                        <Button className="gov-btn gov-btn-neutral" onClick={closeNameModal}>Batal</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={recordModalOpen} toggle={() => setRecordModalOpen(false)}>
                    <ModalHeader toggle={() => setRecordModalOpen(false)}>
                        Rekod Kehadiran Manual
                    </ModalHeader>
                    <ModalBody>
                        {selectedStudent && (
                            <div className="mb-3 p-3 text-black rounded bg-light border">
                                <h5 className="mb-1">{selectedStudent.first_name}</h5>
                                {selectedStudent.moeis_name && selectedStudent.moeis_name !== selectedStudent.first_name && (
                                    <small className="text-muted">Nama Sistem: {selectedStudent.moeis_name}</small>
                                )}
                            </div>
                        )}

                        <div className="form-group">
                            <label>Tarikh Mula</label>
                            <input
                                type="date"
                                className="form-control"
                                value={recordStartDate}
                                onChange={(e) => setRecordStartDate(e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <label>Tarikh Tamat (jika ada)</label>
                            <input
                                type="date"
                                className="form-control"
                                value={recordEndDate}
                                onChange={(e) => setRecordEndDate(e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <label>Status</label>
                            <select
                                className="form-control"
                                value={recordStatus}
                                onChange={(e) => setRecordStatus(e.target.value)}
                            >
                                <option value={0}>Tidak Hadir</option>
                                <option value={1}>Hadir</option>
                            </select>
                        </div>
                        {recordStatus == 0 ? <div className="form-group">
                            <label>Sebab Tidak Hadir / MC</label>
                            <select
                                className="form-control"
                                value={selectedMCReason?.value || ""}
                                onChange={e => {
                                    const selected = mcReasons.find(r => String(r.value) === e.target.value);
                                    setSelectedMCReason(selected || null);
                                }}
                            >
                                <option value="">-- Pilih Sebab --</option>
                                {mcReasons.map(r => (
                                    <option key={r.value} value={r.value}>
                                        {r.label}
                                    </option>
                                ))}
                            </select>

                        </div> : null}
                        {recordStatus != 0 ? <div className="form-group">
                            <label>Catatan</label>
                            <input
                                type="text"
                                className="form-control"
                                value={recordRemarks}
                                onChange={(e) => setRecordRemarks(e.target.value)}
                            />
                        </div> : null}
                    </ModalBody>
                    <ModalFooter>
                        <Button className="gov-btn gov-btn-primary" onClick={submitManualAttendance}>Hantar</Button>
                        <Button className="gov-btn gov-btn-neutral" onClick={() => setRecordModalOpen(false)}>Batal</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={deleteModalOpen} toggle={closeDeleteModal}>
                    <ModalHeader toggle={closeDeleteModal}>Sahkan Padam</ModalHeader>
                    <ModalBody>
                        {studentToDelete && (
                            <div>
                                Adakah anda pasti mahu <b>memadam</b> pegawai "<b>{studentToDelete.first_name}</b>"? <br />
                                Tindakan ini <b>tidak boleh dibatalkan</b>.
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="gov-btn gov-btn-danger"
                            onClick={confirmDeleteStudent}
                            disabled={deleting}
                            style={{
                                minWidth: 120,
                                fontWeight: 700,
                                boxShadow: '0 2px 10px #0B4C9C55',
                                background: 'linear-gradient(90deg, #0B4C9C 0%, #0F65C9 100%)',
                                border: 'none',
                                borderRadius: '30px',
                                fontSize: '1rem',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 8,
                                opacity: deleting ? 0.7 : 1,
                                transition: 'all 0.2s'
                            }}
                        >
                            {deleting ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                    Sedang Dipadam...
                                </>
                            ) : (
                                <>Padam</>
                            )}
                        </Button>

                        <Button className="gov-btn gov-btn-neutral" onClick={closeDeleteModal}>Batal</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={registerModalOpen} toggle={() => setRegisterModalOpen(false)} size="lg">
                    <ModalHeader toggle={() => setRegisterModalOpen(false)}>
                        Daftar Pegawai Baharu
                    </ModalHeader>
                    <ModalBody>
                        {/* Tabs */}
                        <ul className="nav nav-tabs mb-3">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "manual" ? "active" : ""}`}
                                    onClick={() => setActiveTab("manual")}
                                >
                                    Manual
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "csv" ? "active" : ""}`}
                                    onClick={() => setActiveTab("csv")}
                                >
                                    Muat Naik CSV
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "raw" ? "active" : ""}`}
                                    onClick={() => setActiveTab("raw")}
                                >
                                    Isi Senarai
                                </button>
                            </li>
                        </ul>
                        {/* Isi Senarai */}
                        {activeTab === "raw" && (
                            <div className="p-3 border rounded">
                                <p className="text-muted">
                                    Tampal atau taip nama pegawai di bawah, satu nama setiap baris.
                                    Setiap baris akan dianggap sebagai satu pegawai baharu.
                                </p>

                                <textarea
                                    className="form-control mb-3"
                                    rows="8"
                                    placeholder="Masukkan satu nama setiap baris..."
                                    value={rawInput}
                                    onChange={async (e) => {
                                        setRawInput(e.target.value);
                                        const lines = e.target.value
                                            .split("\n")
                                            .map(line => line.trim())
                                            .filter(line => line.length > 0);
                                        setRawNames(lines);
                                        if (lines.length > 0) {
                                            try {
                                                const headers = {
                                                    'Content-Type': 'application/json',
                                                    'token': localStorage.getItem("token"),
                                                };
                                                const response = await API.post(
                                                    "/student/bulkCheckByMoeisName",
                                                    { names: lines },
                                                    { headers }
                                                );

                                                if (response.data.response_code === 1000) {
                                                    setRawCheckResults(response.data.data);
                                                } else {
                                                    toast.error(response.data.message || "Gagal menyemak pegawai sedia ada");
                                                }
                                            } catch (err) {
                                                console.error("Raw check error:", err);
                                                toast.error("Ralat menyemak nama yang dimasukkan");
                                            }
                                        } else {
                                            setRawCheckResults(null);
                                        }
                                    }}
                                />
                                {rawNames.length > 0 && (
                                    <div className="mt-3">
                                        <h6 className="fw-bold">Pratonton ({rawNames.length} pegawai):</h6>
                                        <ul className="list-group" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                            {rawNames.map((name, idx) => {
                                                const foundStudent = rawCheckResults?.found?.find(
                                                    f => f.moeis_name.trim() === name.trim()
                                                );
                                                const notFound = rawCheckResults?.not_found?.includes(name);

                                                const statusInfo = foundStudent
                                                    ? statusMap[String(foundStudent.status)] || { text: "Unknown", color: "dark" }
                                                    : null;

                                                return (
                                                    <li
                                                        key={idx}
                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                        style={{
                                                            backgroundColor: foundStudent ? "#fff8e1" : "#e8f5e9", // yellow if found, green if new
                                                            borderLeft: foundStudent ? "4px solid #ffb300" : "4px solid #43a047", // orange if exists, green if new
                                                        }}
                                                    >
                                                        <div className="d-flex flex-column">
                                                            <span className="fw-semibold">{idx + 1}. {name}</span>

                                                            {foundStudent && (
                                                                <small className="text-muted">
                                                                    Sudah wujud di <b>{foundStudent.class_name}</b>{" "}
                                                                    <span className={`badge bg-${statusInfo.color} ms-1`}>
                                                                        {statusInfo.text}
                                                                    </span>
                                                                </small>
                                                            )}

                                                            {notFound && (
                                                                <span className="badge bg-success mt-1" style={{ width: "fit-content" }}>
                                                                    Pegawai Baharu
                                                                </span>
                                                            )}
                                                        </div>

                                                        <button
                                                            className="btn gov-btn gov-btn-danger"
                                                            onClick={() => {
                                                                setRawNames(prev => prev.filter((_, i) => i !== idx));
                                                                setRawInput(prev =>
                                                                    prev.split("\n").filter((_, i) => i !== idx).join("\n")
                                                                );
                                                            }}
                                                        >
                                                            Remove
                                                        </button>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}

                            </div>
                        )}
                        {/* Manual Registration */}
                        {activeTab === "manual" && (
                            <div>
                                <div className="form-group mb-3">
                                    <label>Nama</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={newStudent.first_name}
                                        onChange={(e) =>
                                            setNewStudent({ ...newStudent, first_name: e.target.value })
                                        }
                                        placeholder="Masukkan nama pegawai"
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label>Nama Sistem</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={newStudent.moeis_name}
                                        onChange={(e) =>
                                            setNewStudent({ ...newStudent, moeis_name: e.target.value })
                                        }
                                        placeholder="Masukkan nama penuh dalam sistem"
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label>Jabatan</label>
                                    <select
                                        className="form-control"
                                        value={newStudent.class_id}
                                        onChange={(e) =>
                                            setNewStudent({ ...newStudent, class_id: e.target.value })
                                        }
                                    >
                                        <option value="">-- Pilih Jabatan --</option>
                                        {allClasses.map((cls) => (
                                            <option key={cls.class_id} value={cls.class_id}>
                                                {cls.class_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}

                        {/* Muat Naik CSV */}
                        {activeTab === "csv" && (
                            <div className="p-3 border rounded">
                                <p className="text-muted">
                                    Muat naik fail CSV dengan <b>NAMA PENUH sahaja</b> (satu nama setiap baris).
                                    Semua pegawai akan didaftarkan di bawah jabatan semasa.
                                </p>
                                <input
                                    type="file"
                                    accept=".csv"
                                    className="form-control"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (!file) return;

                                        if (
                                            file.type !== "text/csv" &&
                                            file.type !== "application/vnd.ms-excel" && // some browsers report CSV as this
                                            !file.name.toLowerCase().endsWith(".csv")
                                        ) {
                                            toast.error("Hanya fail CSV dibenarkan.", { autoClose: 5000 });
                                            e.target.value = ""; // clear the input
                                            setCsvFile(null);
                                            setParsedCsvNames([]);
                                            return;
                                        }

                                        setCsvFile(file);

                                        Papa.parse(file, {
                                            header: false,
                                            complete: async (results) => {
                                                const names = results.data
                                                    .map(row => row[0]?.trim())
                                                    .filter(name => name);

                                                setParsedCsvNames(names);

                                                if (names.length > 0) {
                                                    try {
                                                        const headers = {
                                                            'Content-Type': 'application/json',
                                                            'token': localStorage.getItem("token"),
                                                        };
                                                        const response = await API.post(
                                                            "/student/bulkCheckByMoeisName",
                                                            { names },
                                                            { headers }
                                                        );

                                                        if (response.data.response_code === 1000) {
                                                            setCsvCheckResults(response.data.data);
                                                        } else {
                                                            toast.error(response.data.message || "Gagal menyemak pegawai sedia ada");
                                                        }
                                                    } catch (err) {
                                                        console.error("Check error:", err);
                                                        toast.error("Ralat menyemak nama dalam CSV");
                                                    }
                                                }
                                            }
                                        });
                                    }}
                                />

                                {csvFile && (
                                    <div className="mt-3">
                                        <h6 className="fw-bold">Pratonton ({parsedCsvNames.length} pegawai):</h6>
                                        <ul className="list-group" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                            {parsedCsvNames.map((name, idx) => {
                                                const foundStudent = csvCheckResults?.found?.find(
                                                    f => f.moeis_name.trim() === name.trim()
                                                );
                                                const notFound = csvCheckResults?.not_found?.includes(name);

                                                // Choose status info if found
                                                const statusInfo = foundStudent ? statusMap[String(foundStudent.status)] || { text: "Unknown", color: "dark" } : null;

                                                return (
                                                    <li
                                                        key={idx}
                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                        style={{
                                                            backgroundColor: foundStudent ? "#fff8e1" : "#e8f5e9", // yellowish if found, greenish if new
                                                            borderLeft: foundStudent ? "4px solid #ffb300" : "4px solid #43a047", // orange for existing, green for new
                                                        }}
                                                    >
                                                        <div className="d-flex flex-column">
                                                            <span className="fw-semibold">{idx + 1}. {name}</span>

                                                            {foundStudent && (
                                                                <small className="text-muted">
                                                                    Sudah wujud di <b>{foundStudent.class_name}</b>{" "}
                                                                    <span className={`badge bg-${statusInfo.color} ms-1`}>
                                                                        {statusInfo.text}
                                                                    </span>
                                                                </small>
                                                            )}

                                                            {notFound && (
                                                                <span className="badge bg-success mt-1" style={{ width: "fit-content" }}>
                                                                    Pegawai Baharu
                                                                </span>
                                                            )}
                                                        </div>

                                                        <button
                                                            className="btn gov-btn gov-btn-danger"
                                                            onClick={() => setParsedCsvNames(prev => prev.filter((_, i) => i !== idx))}
                                                        >
                                                            Remove
                                                        </button>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}

                            </div>
                        )}
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            className="gov-btn gov-btn-primary"
                            disabled={registering}
                            onClick={async () => {
                                setRegistering(true);
                                try {
                                    const headers = { token: localStorage.getItem("token") };
                                    let payload = [];

                                    if (activeTab === "manual") {
                                        if (!newStudent.first_name || !newStudent.class_id) {
                                            toast.error("Sila lengkapkan semua maklumat yang diperlukan.", { autoClose: 5000 });
                                            setRegistering(false);
                                            return;
                                        }
                                        payload = [newStudent]; // wrap in array
                                    } else if (activeTab === "csv") {
                                        if (parsedCsvNames.length === 0) {
                                            toast.error("Tiada nama pegawai yang sah dalam CSV.", { autoClose: 5000 });
                                            setRegistering(false);
                                            return;
                                        }
                                        payload = parsedCsvNames.map(name => ({
                                            first_name: name,
                                            moeis_name: name,
                                            class_id: classId,
                                        }));
                                    } else if (activeTab === "raw") {
                                        if (rawNames.length === 0) {
                                            toast.error("Tiada nama pegawai yang sah dimasukkan.", { autoClose: 5000 });
                                            setRegistering(false);
                                            return;
                                        }
                                        payload = rawNames.map(name => ({
                                            first_name: name,
                                            moeis_name: name,
                                            class_id: classId,
                                        }));
                                    }

                                    const response = await API.post(
                                        "/student/registerStudentByAdminPortal",
                                        { students: payload },
                                        { headers }
                                    );

                                    if (response.data.response_code === 1000) {
                                        toast.success("Pegawai berjaya didaftarkan!", { autoClose: 5000 });
                                        fetchStudentsAttendanceDetail(selectedDate);
                                        fetchStudentsAttendanceSummary(selectedDate);
                                        setRegisterModalOpen(false);
                                        setNewStudent({ first_name: "", moeis_name: "", class_id: classId });
                                        setCsvFile(null);
                                        setParsedCsvNames([]);
                                        setRawInput("");
                                        setRawNames([]);
                                    } else {
                                        toast.error(response.data.message || "Gagal mendaftar", { autoClose: 5000 });
                                    }
                                } catch (error) {
                                    toast.error("Ralat mendaftar pegawai", { autoClose: 5000 });
                                } finally {
                                    setRegistering(false);
                                }
                            }}
                        >
                            {registering ? "Sedang Diproses..." : "Daftar Pegawai"}
                        </Button>

                        <Button className="gov-btn gov-btn-neutral" onClick={() => setRegisterModalOpen(false)}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={confirmAbsentModalOpen} toggle={() => setConfirmAbsentModalOpen(false)}>
                    <ModalHeader toggle={() => setConfirmAbsentModalOpen(false)}>
                        Confirm Tanda Semua Sebagai Tidak Hadir
                    </ModalHeader>
                    <ModalBody>
                        <div className="form-group mb-3">
                            <label><b>Julat Tarikh</b></label>
                            <div className="d-flex gap-2">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={startBulkDate}
                                    onChange={(e) => setStartBulkDate(e.target.value)}
                                />
                                <input
                                    type="date"
                                    className="form-control"
                                    value={endBulkDate}
                                    onChange={(e) => setEndBulkDate(e.target.value)}
                                />
                            </div>
                        </div>

                        <p>
                            Pilih <b>sebab tidak hadir</b> dan sahkan untuk menanda semua pegawai belum direkod sebagai
                            <span className="text-danger fw-bold"> Tidak Hadir</span>.
                        </p>

                        <div className="form-group mb-3">
                            <label><b>Sebab Tidak Hadir</b></label>
                            <select
                                className="form-control"
                                value={selectedBulkMCReason?.value || ""}
                                onChange={e => {
                                    const selected = mcReasons.find(r => String(r.value) === e.target.value);
                                    setSelectedBulkMCReason(selected || null);
                                }}
                            >
                                <option value="">-- Pilih Sebab --</option>
                                {mcReasons.map(r => (
                                    <option key={r.value} value={r.value}>
                                        {r.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <ModalFooter>
                            <Button
                                className="gov-btn gov-btn-success"
                                onClick={confirmMarkAllAsAbsent}
                                disabled={loading}
                            >
                                {loading ? "Sedang Diproses..." : "Confirm"}
                            </Button>
                            <Button
                                className="gov-btn gov-btn-neutral"
                                onClick={() => setConfirmAbsentModalOpen(false)}
                            >
                                Cancel
                            </Button>
                        </ModalFooter>
                        <Table bordered hover responsive>
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Profil</th>
                                    <th>Nama</th>
                                    <th>Tindakan</th>
                                </tr>
                            </thead>
                            <tbody>
                                {unrecordedList.map((s, idx) => (
                                    <tr key={s.student_uuid}>
                                        <td>{idx + 1}</td>
                                        <td>
                                            {s.profile_pic ? (
                                                <img
                                                    src={s.profile_pic}
                                                    alt={s.first_name}
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "50%",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            ) : (
                                                <span className="text-muted">N/A</span>
                                            )}
                                        </td>
                                        <td className="fw-semibold">{s.moeis_name}</td>
                                        <td>
                                            <Button
                                                className="gov-btn gov-btn-danger"
                                                size="sm"
                                                onClick={() => removeFromUnrecordedList(s.student_uuid)}
                                            >
                                                Buang
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </ModalBody>
                </Modal>
                {/* Archive Modal */}
                <Modal
                    isOpen={isArchiveModalOpen}
                    toggle={() => setIsArchiveModalOpen(!isArchiveModalOpen)}
                    size="md" // Medium is usually better for lists to keep focus
                    centered
                    contentClassName="border-0 shadow-lg"
                >
                    <div className="p-4 border-bottom bg-white rounded-top">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div className="archive-icon-soft rounded-circle d-flex align-items-center justify-content-center mr-3">
                                    <i className="fa fa-archive"></i>
                                </div>
                                <div>
                                    <h5 className="mb-0 font-weight-bold" style={{ color: '#1a1d21' }}>Arkib Pegawai</h5>
                                    <p className="text-muted mb-0 small">Semak senarai untuk <span className="text-dark font-weight-medium">{className}</span></p>
                                </div>
                            </div>
                            <button type="button" className="close shadow-none" onClick={() => setIsArchiveModalOpen(false)}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>

                    <ModalBody className="p-0 bg-white">
                        {/* Subtle Instruction Bar */}
                        <div className="px-4 py-2 bg-light text-muted small border-bottom">
                            <i className="fa fa-info-circle mr-2"></i>
                            Pegawai di bawah akan diarkibkan. Buang pegawai yang masih perlu kekal aktif.
                        </div>

                        {/* Scrollable List Container */}
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {studentsToArchive.length > 0 ? (
                                <div className="list-group list-group-flush">
                                    {studentsToArchive.map((student) => (
                                        <div key={student.student_uuid} className="list-group-item px-4 py-3 border-0 d-flex align-items-center justify-content-between"
                                            style={{ transition: 'background 0.2s ease' }}>
                                            <div className="d-flex align-items-center">
                                                <div className="position-relative">
                                                    <img
                                                        src={student.profile_pic || 'default-avatar.png'}
                                                        alt=""
                                                        className="rounded-circle border"
                                                        style={{ width: '38px', height: '38px', objectFit: 'cover' }}
                                                    />
                                                    <span className="position-absolute border border-white rounded-circle"
                                                        style={{ width: '10px', height: '10px', background: '#2ecc71', bottom: '0', right: '2px' }}></span>
                                                </div>
                                                <div className="ml-3">
                                                    <div className="font-weight-bold mb-0" style={{ color: '#2d3436', fontSize: '0.95rem' }}>
                                                        {student.first_name}
                                                    </div>
                                                    <div className="text-muted small" style={{ fontSize: '0.8rem' }}>
                                                        ID: {student.moeis_name || 'N/A'}
                                                    </div>
                                                </div>
                                            </div>

                                            <Button
                                                color="link"
                                                className="gov-btn-link hover-fade"
                                                onClick={() => handleRemoveFromArchiveList(student.student_uuid)}
                                                style={{ fontSize: '0.85rem' }}
                                            >
                                                <i className="fa fa-minus-circle mr-1"></i> Buang
                                            </Button>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center py-5">
                                    <div className="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px' }}>
                                        <i className="fa fa-users text-muted fa-lg"></i>
                                    </div>
                                    <p className="text-muted mb-0">Tiada pegawai dipilih untuk diarkibkan.</p>
                                </div>
                            )}
                        </div>
                    </ModalBody>

                    <ModalFooter className="p-4 bg-light border-0 rounded-bottom">
                        <div className="d-flex w-100 align-items-center justify-content-between">
                            <span className="text-muted small">
                                <strong>{studentsToArchive.length}</strong> pegawai dipilih
                            </span>
                            <div className="d-flex">
                                <Button
                                    color="link"
                                    className="gov-btn-link mr-3"
                                    onClick={() => setIsArchiveModalOpen(false)}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className="gov-btn gov-btn-danger px-4"
                                    onClick={handleBulkArchiveClass}
                                    disabled={isArchiving || studentsToArchive.length === 0}
                                >
                                    {isArchiving ? (
                                        <span className="spinner-border spinner-border-sm" />
                                    ) : (
                                        'Sahkan & Arkib'
                                    )}
                                </Button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
                <AddTimetableModal
                    subjects={subjects}
                    isOpen={addModalOpen}
                    onClose={() => setAddModalOpen(false)}
                    classId={classId}
                    teachers={teachers}
                    onAdded={fetchTimetable}
                    selectedDay={selectedDay}
                    existingDayTimetable={filteredTimetable}
                />
            </div>
        </Fragment>
    );
};

export default DepartmentProfile;
